<template lang="pug">
section.homeContact
  #contact.homeContact-background
  .homeContact-container
    .homeContact-form
      h2.homeContact-title Contact me
      .inputGroup(:class='{ _error: $v.name.$error }')
        label.inputGroup-label(for='name') Name
        input#name.inputGroup-input(v-model.trim='$v.name.$model')
        .error(v-if='$v.name.$error && !$v.name.required') Field is required
      .inputGroup(:class='{ _error: $v.email.$error }')
        label.inputGroup-label(for='email') E-mail
        input#email.inputGroup-input(v-model.trim='$v.email.$model')
        .error(v-if='$v.email.$error && !$v.email.required') Field is required
        .error(v-if='$v.email.$error && !$v.email.email') Email is invalid
      //- .inputGroup(:class='{ _error: $v.phone.$error }')
      //-   label.inputGroup-label(for='tel') Phone
      //-   input#tel.inputGroup-input(v-model.trim='$v.phone.$model', type='tel')
      //-   .error(v-if='$v.phone.$error && !$v.phone.required') Field is required
      //-   .error(v-if='$v.phone.$error && !$v.phone.numeric') Must accepts only numerics.
      .inputGroup(:class='{ _error: $v.message.$error }')
        label.inputGroup-label(for='message') Message
        input#message.inputGroup-input(v-model.trim='$v.message.$model')
        .error(v-if='$v.message.$error && !$v.message.required') Field is required
      .button._submit(:class='{ _loading: submitStatus == "loading..." }', @click='submit') {{ submitStatus }}
    //- .homeContact-divider
    .homeContact-info

      .infoBlock
        .infoBlock-contacts
          .infoBlock-title Contacts
          a.infoBlock-contact(href='mailto:ian.hurdle@theagencyre.com')
            span.infoBlock-text ian.hurdle@theagencyre.com
          a.infoBlock-contact(href='tel:6492471993')  
            span.infoBlock-text 649.247.1993

        .infoBlock-location
          .infoBlock-title Location
          span.infoBlock-text 7/8 Salt Mills Plaza, Grace Bay Road
          span.infoBlock-text Turks & Caicos, TKCA1ZZ
        .infoBlock-socials
          .infoBlock-title Follow me
          Social.infoBlock-socials-wrapper

      //- .contactBlock
      //-   .contactBlock-name Ian Hurdle
      //-   .contactBlock-rank FOUNDER & DIRECTOR
      //-   a.contactBlock-contact(href='tel:6492471993')
      //-     SvgComponent(name='phone')
      //-     span 649.332.2612
      //-   a.contactBlock-contact(href='mailto:ian.hurdle@theagencyre.com')
      //-     SvgComponent(name='email')
      //-     span ian.hurdle@theagencyre.com

</template>

<script>
  import { validationMixin } from 'vuelidate';
  import { required, email, numeric } from 'vuelidate/lib/validators';
  export default {
    mixins: [validationMixin],
    data() {
      return {
        submitStatus: 'send request',
        name: '',
        email: '',
        phone: '',
        message: '',
      };
    },
    components: {
      SvgComponent: () => import('@/components/SvgComponent'),
      Social: () => import('@/components/Social'),
      
    },
    validations: {
      name: { required },
      email: { required, email },
      phone: { required, numeric },
      message: {},
    },
    methods: {
      async submit() {
        if (this.submitStatus == 'OK' || this.submitStatus == 'loading...') {
          return;
        }
        console.log('submit!');
        this.$v.$touch();
        if (this.$v.$invalid) {
          console.log('form is invalid!');
          this.submitStatus = 'invalid form';
        } else {
          this.submitStatus = 'loading...';
          const res = await this.$store.dispatch('sendEmail', {
            name: this.name,
            email: this.email,
            phone: this.phone,
            message: this.message,
          });
          this.submitStatus = res.statusText;
          this.$router.push({ name: 'SuccessPage' });
        }
      },
    },
  };
</script>

<style lang="scss">
  .homeContact {
    color: #FFFAF3;
    
    
    &-title {
      margin-bottom: 24px;
      font-family: 'Abhaya Libre';
      @include small {
        margin-bottom: 40px;
      }
      @include tablet {
        margin-bottom: 0px;
        //  margin-top: 56px;
        text-align: left;
        font-size: 40px;
      }
    }
    display: contents;
    &-divider {
      width: 2px;
      flex-shrink: 0;
      //  height: 100%;
      background: #c4c4c4;
      margin: 0 150px;
      // align-self: stretch;

      // flex-grow: 1;
      @include middle {
        margin: 0 90px 0 45px;
      }
      @include small {
        margin: 0 px;
      }
    }
    &-background {
      background: #1F1E1E;
    }
    &-container {
      padding: 120px 0 60px;
      display: flex;
      justify-content: space-between;
      
      
      @include middle {
        padding: 100px 0 40px;
      }
      @include small {
        padding: 80px 0 25px;
      }
      @include tablet {
        flex-direction: column;
        padding: 32px 0 32px;
      }
      // align-items: center;
    }
    &-info {
      // flex-grow: 1;
      // width: 50%;
      /* width: 336px; */
      @include tablet {
        width: auto;
      }
    }
    &-form {
      // flex-grow: 1;
      // width: 50%;
      width: 393px;
      // padding: 0 150px;
      @include gap(37px, col);
      display: flex;
      flex-direction: column;
      @include tablet {
        margin-top: 0px;
        width: 100%;
      }
    }
    .inputGroup {
      // height: 61px;
      border-bottom: 1px solid #c4c4c4;
      padding-bottom: 10px;
      /* padding-left: 20px; */
      position: relative;

      @include phone {
        margin-top: 32px;
      }
      &-label {
        display: block;
        margin-bottom: 10px;
        font-size: 16px;
        font-weight: 800;
      }
      &-input {
        font-size: 18px;
        @include tablet {
          width: 100%;
        }
      }
      &._error {
        border-color: $red;
      }
      .error {
        position: absolute;
        bottom: -1.5em;
        left: 0px;
        font-size: 16px;
        line-height: 19px;
        color: $red;
      }
    }

    .infoBlock {
      margin-top: 64px;
      display: grid;
      grid-template-columns: repeat(2, 285px);
      gap: 32px;

      @include phone {
        margin-top: 56px;
        grid-template-columns: 1fr;
        gap: 32px;
      }

      &-contact{
        display: flex;
        align-items: center;
        
      }

      &-title { 
        font-weight: 700;
        font-size: 24px;
        line-height: 36px;
        @include phone {
          font-size: 20px;
          line-height: 20px;
          margin-bottom: 12px;
        }
      }
      &-text{
        line-height: 36px;
        @include phone {
          font-size: 16px;
          line-height: 26px;
          margin-bottom: 8px;
        }
      }

      &-socials-wrapper{
        display: flex;
        align-items: center;
        gap: 6px;
        margin-top: 10px;
      }



    }

    .contactBlock {
      @include gap(20px, col);
      @include tablet {
        border: solid 5px white;
        padding: 32px;
        svg {
          flex-shrink: 0;
        }
      }
      &-name {
        font-weight: 600;
        font-size: 30px;
      }
      &-rank {
        font-weight: 300;
        font-size: 16px;
      }
      &-contact {
        font-size: 20px;
        line-height: 36px;
        display: flex;
        align-items: center;
        @include gap(20px, row);
        svg {
          color: #d41e34;
        }
        @include tablet {
          font-size: 20px;
        }
      }
    }
  }
</style>
